import './styles.css';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ReactCodeInput from 'react-verification-code-input';

import { useverifyVendorPasscodeMutation } from '../../apollo';
import QuestionIcon from '../../assets/icons/question.svg';
import { colors } from '../../assets/styles';
import { getErrorMessage } from '../../helpers';
import Icon from '../Icon';
import { LoadingSpinner } from '../LoadingSpinner';
import { VendorPasscodeInfoModal } from '../VendorPasscodeInfoModal';
import styles from './styles';

interface VendorPasscodeVerificationProps {
  isVirtualDirectoryEnabled: boolean;
  leasingOfficeDisplayName: string;
  onVerified: () => void;
}

export const VendorPasscodeVerification: React.FC<VendorPasscodeVerificationProps> = (props) => {
  const navigate = useNavigate();
  const accessPointId = useParams().accessPointId as string;
  const { isVirtualDirectoryEnabled, leasingOfficeDisplayName, onVerified } = props;

  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [verificationCode, setVerificationCode] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [verifyVendorPasscode, { loading }] = useverifyVendorPasscodeMutation();
  const regex = /^[a-z0-9]+$/i;
  const inputs = document.querySelectorAll('input[data-id]');

  useEffect(() => {
    const thirdElement = document.querySelector('input[data-id="2"]');
    thirdElement?.insertAdjacentHTML(
      'afterend',
      '<p class="h1" style="font-size: 50px; font-weight: 300; line-height :50px">-</p>',
    );
  }, []);

  useEffect(() => {
    if (errorMessage && verificationCode.length < 6) {
      setErrorMessage(null);
    }
  }, [verificationCode, errorMessage]);

  useEffect(() => {
    const handleBeforeInput = (event: Event) => {
      const inputEvent = event as InputEvent;
      const isAlphanumeric = /^[a-z0-9]*$/i.test(inputEvent.data ?? '');
      if (!isAlphanumeric) {
        event.preventDefault();
      }
    };

    inputs.forEach((input: Element) => {
      input.addEventListener('beforeinput', handleBeforeInput);
    });

    return () => {
      inputs.forEach((input) => {
        input.removeEventListener('beforeinput', handleBeforeInput);
      });
    };
  }, [verificationCode]);

  return (
    <div>
      <div className={styles.header}>
        <div
          className={styles.headerLeft}
          onClick={() => navigate(-1)}
        >
          <div className={styles.headerLeftIcon}>
            <Icon.ArrowLeft color={colors.white} />
          </div>
        </div>
        <div className={styles.headerText}>
          Vendor Passcode
        </div>
        <div className={styles.headerRight}>
          <button className={styles.buttonWithIcon} onClick={() => setInfoModalOpen(true)}>

            <img src={QuestionIcon} alt="" className={styles.infoIcon} />
          </button>
        </div>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.verificationWrapper}>
          <p className={styles.title} style={{ fontWeight: 600 }}>ENTER VENDOR PASSCODE</p>
          <div className={styles.spacer}/>
          <ReactCodeInput
            type="text"
            className="verification-input"
            fieldWidth={38}
            onChange={(val) => {
              if (regex.test(val)) {
                setVerificationCode(val);
              }
            }}
            onComplete={async (val) => {
              const code = `${val.toUpperCase().substring(0, 3)}-${val.toUpperCase().substring(3)}`;

              try {
                const result = await verifyVendorPasscode({
                  variables: {
                    input: { accessPointId, code },
                  },
                });

                if (result.data?.vendorPassUserRole) {
                  onVerified();
                }
              } catch (error) {
                setErrorMessage(getErrorMessage(error as Error));
              }
            }}
          />
          {loading && <LoadingSpinner />}
          <div className={styles.spacer}/>
          <div className={styles.spacer}/>
          <span className={styles.errorWrapper}>
            {errorMessage}
          </span>
        </div>
        <VendorPasscodeInfoModal
          closeModal={() => setInfoModalOpen(false)}
          isOpen={infoModalOpen}
          isVirtualDirectoryEnabled={isVirtualDirectoryEnabled}
          leasingOfficeDisplayName={leasingOfficeDisplayName}
        />
      </div>
    </div>
  );
};

export default VendorPasscodeVerification;
